document.addEventListener('DOMContentLoaded', () => {
    const menuDrawer = document.querySelector('[data-menu-drawer]');
    const menu = document.querySelector('.header__menu');

    let scrollTop = 0;

    menuDrawer?.addEventListener('click', () => {
        scrollTop = window.scrollY;
        menu.classList.add('element--opened');
        document.body.classList.add('remove-scrolling');
        document.body.style.top = `-${scrollTop}px`;
    });

    const menuBackground = document.querySelector('.menu__background');
    const menuCross = document.querySelector('.menu__cross');
    [menuBackground, menuCross].forEach(element => {
        element.addEventListener('click', () => {
            menu.classList.remove('element--opened');
            document.body.classList.remove('remove-scrolling');
            window.scrollTo({
                top: scrollTop, left: 0, behavior: "instant"
            });
        });
    })

    const mainLinksElements = document.querySelectorAll('.main-links__main-link');
    const mainLinksTitles = document.querySelectorAll('.main-link__title');
    mainLinksTitles.forEach((mainLink, index) => {
        mainLink.addEventListener('click', () => {
            const links = mainLinksElements[index].querySelector('.main-link__links');
            const linksWrapper = mainLinksElements[index].querySelector('.links__wrapper');

            const linkElements = linksWrapper.querySelectorAll('.links__link');
            const linksTitles = linksWrapper.querySelectorAll('.link__title');

            if (mainLink.classList.toggle('element--opened')) {
                links.style.maxHeight = `${linksWrapper.offsetHeight}px`;
            }
            else {
                links.style.maxHeight = '0px';
                linksTitles.forEach((link, subindex) => {
                    const sublinks = linkElements[subindex].querySelector('.link__sublinks');
                    if (sublinks) {
                        link.classList.remove('element--opened');
                        sublinks.style.maxHeight = `0px`;
                    }
                });
            }
            linksTitles.forEach((link, subindex) => {
                link.addEventListener('click', () => {
                    const sublinks = linkElements[subindex].querySelector('.link__sublinks');
                    const sublinksWrapper = linkElements[subindex].querySelector('.sublinks__wrapper');
                    if (sublinks && sublinksWrapper) {
                        if (link.classList.toggle('element--opened')) {
                            sublinks.style.maxHeight = `${sublinksWrapper.offsetHeight}px`;
                            links.style.maxHeight = `${linksWrapper.offsetHeight + sublinksWrapper.offsetHeight}px`;
                        }
                        else {
                            sublinks.style.maxHeight = `0px`;
                            links.style.maxHeight = `${linksWrapper.offsetHeight - sublinksWrapper.offsetHeight}px`;
                        }
                    }
                });
            })
        });
    });
})